import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { get } from 'global/lib/lodash';
import { UserPermission } from '../lib/filter';

export default (props) => {
  const accountSettings = useSelector((state) => get(state, 'auth.accountSettings'));
  const perms = useSelector((state) => get(state, 'auth.permissions'));
  const [nav, setNav] = useState({ tasks: true, assessments: true, library: true });

  const filterPermissionsByNav = () => {
    return UserPermission.filter((f) => {
      let n = get(f, 'nav');
      if (n) {
        if (typeof n === 'function') {
          return n(perms);
        }
        return !!get(nav, n);
      }

      return true;
    });
  };

  useEffect(() => {
    const asettings = (accountSettings || []).find((a) => get(a, 'name') === 'Nav Config');
    setNav(JSON.parse(get(asettings, 'value', JSON.stringify(nav))));

    //for testing
    // setNav({
    //   ...nav,
    //   tasks: false,
    //   // library: true,
    //   assessments: false,
    // })
  }, [accountSettings]);

  return {
    nav,
    filterPermissionsByNav,
  };
};
